import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import {
  handleOpenMasterControl,
  setOpenLocationInitialStateHandler,
  setOpenSpecificLocationInitialStateHandler,
} from '../../components/store/slices/MCIsExpandedSlice';
import { getSpecLocationHandler } from '../../helpers/helpers';

export const useSetZoneOpeningsState = (
  switchData,
  masterControl,
  machineControlHandler,
  swtSystem,
  isOpenMasterControl
) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (masterControl) {
      const locations = Object.keys(switchData).map((_) => false);
      dispatch(
        setOpenLocationInitialStateHandler({
          swtSystem,
          locations,
        })
      );

      if (machineControlHandler) {
      }
    } else if (isOpenMasterControl) {
      dispatch(handleOpenMasterControl({ swtName: swtSystem, status: false }));
    }
  }, [masterControl]);
};
